import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'jquery/dist/jquery.min.js';
// import '../node_modules/font-awesome/css/font-awesome.min.css';
import 'font-awesome/css/font-awesome.min.css';
import * as firebase from 'firebase';


const firebaseConfig = {
    apiKey: "AIzaSyDdfNm__UexQdhrT_elV3TB1eaE2KcrHHQ",
    authDomain: "ipark-app-3143c.firebaseapp.com",
    databaseURL: "https://ipark-app-3143c.firebaseio.com",
    projectId: "ipark-app-3143c",
    storageBucket: "ipark-app-3143c.appspot.com",
    messagingSenderId: "370398523704",
    appId: "1:370398523704:web:6f93442b0c02e153e051cd",
    measurementId: "G-GZ07KKLJ1R"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
